import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';

// Services
import {
  OpentokService,
  UserService
} from "@services/index.service";
import { DialogService } from '@services/auth-guard/dialog.service';

import { TranslateService } from '@ngx-translate/core';
import { ResponseDataBase } from '@interfaces/index.interface';
import { AppConstants } from '@app/appConstants';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-videocall',
  templateUrl: './videocall.page.html',
  styleUrls: ['./videocall.page.scss']
})

export class VideocallComponent implements OnInit {

  slot;
  publisher;
  chatTab: FormGroup;
  chat = {
    message: ''
  };
  msg_history = [];
  loading = true;
  waitingDoctor = true;
  sharingDesktop = false;
  sharingCam = false;
  chatShowed = false;
  myCam;
  myDesktop;
  doctorSharedDesktop = false;
  accepted = false;


  constructor(public router: Router,
    public translate: TranslateService,
    public _userService: UserService,
    private _opentokService: OpentokService,
    public dialogService: DialogService) {

    if (!this._opentokService.videoCallSlot) {
      this.router.navigate(['/user/myappointments']);
    } else {
      this.slot = this._opentokService.videoCallSlot;
      // this.startVideoCall();
    }
    this.chatTab = new FormGroup({
      'message': new FormControl()
    });
  }

  openVideoCall() {
    let link = environment.VIDEOCALL.COMPONENTURL + '?room=' + this._userService.user.patnr + '&role=patient';
    window.open(link, "_blank")
    // Una vez que se inicia la videollamada avisamos a SAP de que el paciente está disponible
    let params = {
      hospitalId: '4010',
      patnr: this._userService.user.patnr,
      slotId: this.slot.id
    };
    this._userService.passToWaitingRoom(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK || response.METADATA.STATUS === AppConstants.STATUS.PAPID_REMOVED) {
      } else {
        console.log('ERROR', response);
      }
    });
  }

  canDeactivate() {
    if (!this._opentokService.videoCallSlot) {
      return true;
    } else {
      let res: any = this.translate.get('YOU_ARE_LEAVING_A_VIDEOCALL');
      return this.dialogService.confirm(res.value);
    }
  }

  handleError(error) {
    if (error) {
      alert(error.message);
    }
  }

  startVideoCall() {
    if (!this.slot.room) {
      this.slot.room = this._userService.user.patnr;
    }
    let self = this;
    this._opentokService.getSessionConfig(this.slot.room)
      .subscribe(data => {
        let config = data as any;
        this._opentokService.initSession(config.apiKey, config.token, config.sessionId)
          .then(response => {
            var session: any = this._opentokService.session;

            // Create chat 
            session.on('signal:msg', function (event) {
              let msg = {
                text: event.data,
                time: moment().format('LT'),
                author: event.from.connectionId === session.connection.connectionId ? 'mine' : 'theirs'
              }
              self.msg_history.push(msg);
              var msg_history_div = document.getElementById("msg_history");
              setTimeout(function () { msg_history_div.scrollTop = msg_history_div.scrollHeight; }, 100);
              // Process the event.data property, if there is any data.
            });

            // Subscribe to a destoyed stream
            session.on('streamDestroyed', function (event) {
              // Si la stream es del desktop del médico 
              if (event.stream.videoType == "screen") {
                self.doctorSharedDesktop = false;
              }
              // Si la stream es la cámara del paciente
              else {
                self.waitingDoctor = true;
              }
            });

            // Subscribe to a newly created stream
            session.on('streamCreated', function (event) {
              // Si la stream es del desktop del médico 
              if (event.stream.videoType == "screen") {
                session.subscribe(event.stream, 'doctor-screen-preview', {
                  insertMode: 'append',
                  width: '400px',
                  height: '225px'
                }, self.handleError);
                self.doctorSharedDesktop = true;
              }
              // Si la stream es la cámara del médico
              else {
                session.subscribe(event.stream, 'subscriber', {
                  insertMode: 'append',
                  height: "100%",
                  width: "100%"
                }, self.handleError);
                self.waitingDoctor = false;
              }
            });

            // Create a publisher
            this.publisher = OT.initPublisher('publisher', {
              insertMode: 'append',
              width: '100px',
              height: '100px'
            }, self.handleError);

            self.myCam = this.publisher;
            self.sharingCam = true;

            this.publisher.on('streamCreated', function (event) {
              self.loading = false;
            });

            // Connect to the session
            session.connect(config.token, function (error) {
              // If the connection is successful, publish to the session
              if (error) {
                self.handleError(error);
              } else {
                session.publish(self.publisher, self.handleError);

              }
            });
          }).catch(e => {
            console.log(e);
          });
      });
  }

  shareDesktop() {
    var self = this;
    var session: any = this._opentokService.session;
    OT.checkScreenSharingCapability(function (response) {
      if (!response.supported || response.extensionRegistered === false) {
        // This browser does not support screen sharing.
      } else if (response.extensionInstalled === false) {
        // Prompt to install the extension.
      } else {
        // Screen sharing is available. Publish the screen.
        var screenPublisher = OT.initPublisher('screen-preview',
          {
            videoSource: 'screen',
            insertMode: 'append',
            width: '400px',
            height: '225px'
          },
          function (error) {
            if (error) {
              // Look at error.message to see what went wrong.
            } else {
              session.publish(screenPublisher, function (error) {
                if (error) {
                  // Look error.message to see what went wrong.
                }
              });
              self.sharingDesktop = true;
            }
          }
        );
        self.myDesktop = screenPublisher;
        screenPublisher.on('mediaStopped', function (event) {
          self.sharingDesktop = false;
        });
      }
    });
  }

  stopShareDesktop() {
    this._opentokService.session.unpublish(this.myDesktop);
    this.sharingDesktop = false;
  }

  stopShareMyCam() {
    this._opentokService.session.unpublish(this.myCam);
    this.sharingCam = false;
  }



  sendChatMessage() {
    if (this.chatTab.value.message) {
      let self = this;
      this._opentokService.session.signal({
        type: 'msg',
        data: self.chatTab.value.message
      }, function (error) {
        if (error) {
          console.log('Error sending signal:', error.name, error.message);
        } else {
          self.chat.message = '';
        }
      });
    }
  }

  finishVideoCall() {
    this.router.navigate(['/user/myappointments']);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    console.log('desconet', this._opentokService.session);
    if (this._opentokService.session) {
      this._opentokService.session.disconnect();
    }
    delete this._opentokService.videoCallSlot;
  }
}
